import { useTranslation, Trans } from "react-i18next"
import './RessourcesPages.css'

function RessourcesPage() {
  const { t } = useTranslation()

  return (
    <div className="ressources-page">

      <h1
        style={{
          fontSize: "30px",
          color: "#0a93d2",
          textAlign: "center"
        }}
      >
        <Trans i18nKey="ressources.title" />
      </h1>

      <br /><br />

      <p>
        <Trans i18nKey="ressources.subtitle" />
      </p>

      <p>{t('ressources.congrats')}</p>
      <p>
        <Trans i18nKey="ressources.intro" />
      </p>
      <p>
        <Trans i18nKey="ressources.intro2" />
      </p>
      <p>
        <Trans i18nKey="ressources.intro3" />
      </p>

      <br />
      <h3 style={{ fontSize: "25px", color: "#0a93d2" }}>
        {t('ressources.axe1.title')}
      </h3>
      <h4>
        <strong>{t('ressources.axe1.subtitle')}</strong>
      </h4>
      <br />
      <p>{t('ressources.axe1.p1')}</p>
      <p>{t('ressources.axe1.p2')}</p>
      <h4>
        <Trans i18nKey="ressources.axe1.recoTitle" />
      </h4>
      <ul>
        <li><Trans i18nKey="ressources.axe1.li1" /></li>
        <li><Trans i18nKey="ressources.axe1.li2" /></li>
        <li><Trans i18nKey="ressources.axe1.li3" /></li>
        <li><Trans i18nKey="ressources.axe1.li4" /></li>
      </ul>

      <br />
      <h3 style={{ fontSize: "25px", color: "#0a93d2" }}>
        {t('ressources.axe2.title')}
      </h3>
      <h4>
        <strong>{t('ressources.axe2.subtitle')}</strong>
      </h4>
      <br />
      <p>{t('ressources.axe2.p1')}</p>
      <p>{t('ressources.axe2.p2')}</p>
      <h4>
        <Trans i18nKey="ressources.axe2.recoTitle" />
      </h4>
      <ul>
        <li><Trans i18nKey="ressources.axe2.li1" /></li>
        <li><Trans i18nKey="ressources.axe2.li2" /></li>
        <li><Trans i18nKey="ressources.axe2.li3" /></li>
        <li><Trans i18nKey="ressources.axe2.li4" /></li>
      </ul>

      <br />
      <h3 style={{ fontSize: "25px", color: "#0a93d2" }}>
        {t('ressources.axe3.title')}
      </h3>
      <h4>
        <strong>{t('ressources.axe3.subtitle')}</strong>
      </h4>
      <br />
      <p>{t('ressources.axe3.p1')}</p>
      <p>{t('ressources.axe3.p2')}</p>
      <h4>
        <Trans i18nKey="ressources.axe3.recoTitle" />
      </h4>
      <ul>
        <li><Trans i18nKey="ressources.axe3.li1" /></li>
        <li><Trans i18nKey="ressources.axe3.li2" /></li>
        <li><Trans i18nKey="ressources.axe3.li3" /></li>
        <li><Trans i18nKey="ressources.axe3.li4" /></li>
      </ul>

      <br />
      <h3 style={{ fontSize: "25px", color: "#0a93d2" }}>
        {t('ressources.axe4.title')}
      </h3>
      <h4>
        <strong>{t('ressources.axe4.subtitle')}</strong>
      </h4>
      <br />
      <p>
        <Trans i18nKey="ressources.axe4.p1" />
      </p>
      <h4>
        <Trans i18nKey="ressources.axe4.recoTitle" />
      </h4>
      <ul>
        <li><Trans i18nKey="ressources.axe4.li1" /></li>
        <li><Trans i18nKey="ressources.axe4.li2" /></li>
        <li><Trans i18nKey="ressources.axe4.li3" /></li>
        <li><Trans i18nKey="ressources.axe4.li4" /></li>
      </ul>

      <br />

      <h3 style={{ fontSize: "25px", color: "#0a93d2" }}>
        {t('ressources.retention.title')}
      </h3>
      <br />
      <p>
        <Trans i18nKey="ressources.retention.p1" />
      </p>
      <p>{t('ressources.retention.p2')}</p>
      <p>
        <Trans i18nKey="ressources.retention.p3" />
      </p>

      <br /><br />

      <h3 style={{ fontSize: "25px", color: "#0a93d2" }}>
        {t('ressources.more.title')}
      </h3>
      <br />
      <p>{t('ressources.more.p1')}</p>
      <a href="#partenaires">
        {t('ressources.more.linkTitle')}
      </a>
      <p>{t('ressources.more.p2')}</p>
    </div>
  )
}

export default RessourcesPage